// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResults_root__C8-V6"};